<template>
  <svg
    width="64"
    height="65"
    viewBox="0 0 64 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_17471_95708)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M63.9993 32.4997C63.9993 50.1726 49.6726 64.4993 31.9997 64.4993C14.3267 64.4993 0 50.1726 0 32.4997C0 14.8267 14.3267 0.5 31.9997 0.5C49.6726 0.5 63.9993 14.8267 63.9993 32.4997ZM45.1429 11.859C48.2679 13.849 49.1878 17.9957 47.1977 21.1208L28.1145 51.0869C26.1244 54.212 21.9777 55.1322 18.8528 53.1421C15.7278 51.152 14.8078 47.0054 16.798 43.8802L35.8811 13.9142C37.8713 10.7891 42.0179 9.86889 45.1429 11.859Z"
        fill="white"
      />
    </g>

    <defs>
      <clipPath id="clip0_17471_95708">
        <rect
          width="64"
          height="64"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
  export default {
    name: 'ZmartaSymbolWhite'
  }
</script>
